export default __webpack_public_path__ + "static/media/wordicon.be4d7479.svg";